import { render, staticRenderFns } from "./GlossaryEditor.vue?vue&type=template&id=0c2945a4&"
import script from "./GlossaryEditor.vue?vue&type=script&lang=js&"
export * from "./GlossaryEditor.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryEditor.vue?vue&type=style&index=0&id=0c2945a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports